import { createVanIconComponent } from "./van"

const Circle = createVanIconComponent("circle")
export default Circle
